import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Receipt, Download, Pencil, Trash2 } from "lucide-react";

const statusColors = {
  brouillon: "bg-slate-100 text-slate-600",
  envoyee: "bg-blue-100 text-blue-700",
  payee: "bg-green-100 text-green-700",
  annulee: "bg-red-100 text-red-600"
};
const statusLabels = {
  brouillon: "Brouillon", envoyee: "Envoyée", payee: "Payée", annulee: "Annulée"
};

export function InvoiceRow({ inv, onStatusChange, onDownload, onEdit, onDelete }) {
  return (
    <div
      className="flex items-center gap-4 p-4 rounded-lg border border-slate-200 hover:border-blue-200 bg-white transition-colors"
      data-testid={"invoice-" + inv.invoice_id}
    >
      <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
        <Receipt className="w-5 h-5 text-blue-600" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-sm font-mono font-medium">{inv.invoice_number}</p>
          <Badge className={statusColors[inv.status] + " text-xs"}>{statusLabels[inv.status]}</Badge>
        </div>
        <div className="flex items-center gap-3 text-xs text-muted-foreground mt-0.5">
          <span>{inv.client_name || "Client"}</span>
          <span>{new Date(inv.created_at).toLocaleDateString("fr-FR")}</span>
          <span>Échéance: {inv.due_date}</span>
        </div>
      </div>
      <div className="text-right mr-2">
        <p className="text-sm font-semibold">{inv.total.toFixed(2)} EUR</p>
        <p className="text-xs text-muted-foreground">TTC</p>
      </div>
      <div className="flex items-center gap-1">
        {inv.status === "brouillon" && (
          <Button variant="outline" size="sm" className="text-xs h-7" onClick={function() { onStatusChange(inv.invoice_id, "envoyee"); }} data-testid={"send-invoice-" + inv.invoice_id}>
            Envoyer
          </Button>
        )}
        {inv.status === "envoyee" && (
          <Button variant="outline" size="sm" className="text-xs h-7 text-green-600" onClick={function() { onStatusChange(inv.invoice_id, "payee"); }} data-testid={"mark-paid-" + inv.invoice_id}>
            Payée
          </Button>
        )}
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={function() { onDownload(inv.invoice_id); }} data-testid={"download-invoice-" + inv.invoice_id}>
          <Download className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={function() { onEdit(inv); }} data-testid={"edit-invoice-" + inv.invoice_id}>
          <Pencil className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8 text-destructive" onClick={function() { onDelete(inv.invoice_id); }} data-testid={"delete-invoice-" + inv.invoice_id}>
          <Trash2 className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
